<template>
    <div class="introductionBox">
       <humanResources tabIndex="1"></humanResources>
       <div class="humanBox">
            <div :class="isMobile?'jobBoxM':'jobBox'" v-for="(item,index) in jobList" :key="index">
                <div class="clearfix">
                    <p class="fl"><span class="jobt">{{item.title}}</span></p>
                    <div class="fr clearfix jobRight" @click="changeState(index)">
                        <span class="fl mt2">{{formatDate(item.addTime)}} 发布</span>
                        <i class="fr mt4" :class="item.show==0?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
                    </div>
                </div>
                <div class="jobInfo" v-if="item.show==1">
                    <div v-html="item.content"></div>
                    <el-button class="onlineBtn" type="primary" @click="online">在线投简历</el-button>
                </div>
            </div>
            <div v-if="!loading && jobList.length === 0">
                <el-empty description="暂无数据"></el-empty>
            </div>
       </div>
    </div>
</template>

<script>
    import humanResources from '@/components/humanResources'
    const NEW_API_BASE = process.env.VUE_APP_NEW_API_URL || '/prod-api'
    const newApi = (path) => NEW_API_BASE + path
	export default {
		name:'EarlierConsultation',
        components:{humanResources},
        data() {
            return {
                jobList: [],
                loading: true,
                pageindex: 1
            }
        },
        mounted() {
           this.getInfo()
        },
        methods:{
            changeState(index){
                var jobList = this.jobList
                jobList[index].show = !jobList[index].show
                for(var i=0;i<jobList.length;i++){
                    if(jobList[index].show==1){
                        if(index!=i){
                            jobList[i].show=0
                        }
                    }
                }
            },

            formatDate(dateStr) {
                if (!dateStr) return ''
                return dateStr.split(' ')[0]
            },

            //获取人才招聘信息
            getInfo(){
                this.loading = true
                this.Request({
                    url: newApi('/hzfglSys/news/public/newsList'),
                    baseURL: '',
                    method: 'get',
                    data: {
                        pageindex: this.pageindex,
                        pagesize: 11,
                        webcode: 'web_100160'
                    }
                }).then((res) => {
                    const data = res.data
                    const rows = (data && data.rows) || []
                    for(var i=0;i<rows.length;i++){
                        rows[i].show = 1
                        if(rows[i].content){
                            var el = document.createElement('textarea')
                            el.innerHTML = rows[i].content
                            rows[i].content = el.value
                        }
                    }
                    this.jobList = rows
                }).finally(() => {
                    this.loading = false
                })
            },
            //在线写简历
            online(){
                window.location.assign('/humanResources/resume')
            }
        }
	}
</script>

<style scoped>
   .humanBox{
       background-color: #F7F8F9;
       padding-top: 42px;
       padding-bottom: 42px;
   }
   .jobBox{
        width: 1200px;
        margin: 0 auto;
        padding: 30px;
        background-color: #fff;
        margin-bottom: 16px;
   }
   .jobBoxM{
        width: 100%;
        padding: 10px;
        background-color: #fff;
   }
   .jobt{
        font-size: 18px;
        font-weight: bold;
        margin-right: 30px;
   }
   .money{
        color: #FE574A;
   }
   .jobRight{
        width: 143px;
        color: #666;
        font-size: 14px;
        cursor: pointer;
   }
   .jobRight:hover i{
        color: #247CD6;
   }
   .jobInfo{
        border-top: 1px solid #EBEBEB;
        padding-top: 40px;
        font-size: 14px;
        margin-top: 15px;
        padding-bottom: 20px;
   }
   .jobInfos{
        margin-top: 25px;
        color: #666;
        line-height: 30px;
   }
   .onlineBtn{
        margin-top: 41px;
   }
</style>